module.exports = __webpack_public_path__ + "h5/img/live-logo.cf66ded0.gif";